/**
 * LoadingSpinner - データ取得中のローディング表示
 */
const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="w-10 h-10 border-4 border-pink-300 border-t-pink-600 rounded-full animate-spin"></div>
      <p className="mt-4 text-sm text-gray-600">読み込み中...</p>
    </div>
  );
};

export default LoadingSpinner;
